import { MenuList, MenuItem, styled, Box, Theme } from '@mui/material';
import Button from 'components/Button';

export const FiltersBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: theme.layout.spacing.small,
}));

export const FiltersButton = styled(Button)(({ theme }) => ({
  borderRadius: 0,
  border: `1px solid ${theme.greys.GREY1}`,
  padding: '5px 0 5px 8px',
  '& .MuiButton-endIcon': {
    width: '32px',
    height: '32px',
    borderLeft: `1px solid ${theme.greys.GREY1}`,
    padding: '7px 3.5px',
    fontSize: 'small',
  },
  '&:hover, &.active': {
    backgroundColor: theme.colors.active,
    color: theme.colors.white,
    borderColor: theme.colors.active,
    '& .MuiButton-endIcon': {
      borderLeftColor: theme.colors.white,
    },
  },
}));

const getFiltersBoxStyle = (theme: Theme) => ({
  backgroundColor: theme.colors.white,
  boxShadow: `0 0 6px ${theme.greys.GREY1}`,
  color: theme.colors.black,
  fontSize: '14px',
  borderRadius: 2,
  margin: `8px ${theme.layout.spacing.small}`,
  padding: 0,
  zIndex: theme.layers.top,
});

export const FiltersMenuList = styled(MenuList)(({ theme }) => ({
  ...getFiltersBoxStyle(theme),
  marginRight: 0,
}));

export const FiltersMenuItem = styled(MenuItem)(({ theme }) => ({
  justifyContent: 'space-between',
  borderRadius: 0,
  margin: 0,
  padding: '5px 0 5px 8px',
  '&:hover': {
    backgroundColor: theme.greys.GREY6,
  },
  '&.active': {
    backgroundColor: theme.colors.active,
    color: theme.colors.white,
  },
}));

export const FiltersMenuInputBox = styled(Box)(({ theme }) => getFiltersBoxStyle(theme));
